/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@mui/material';
import { DialogDefaultV2, InputV2 } from '../../../components/v2';

const ExpirarDialog = ({ open, onClose, onConfirm }) => {
  const [justificativa, setJustificativa] = useState('');
  const [justificativaError, setJustificativaError] = useState(false);

  useEffect(() => {
    if (open) {
      setJustificativa('');
      setJustificativaError(false);
    }
  }, [open]);

  const handleConfirm = () => {
    if (!justificativa || !justificativa.trim()) {
      setJustificativaError(true);
      return;
    }

    onConfirm(justificativa.trim());
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onClose}
      handlerConfirm={handleConfirm}
      title="Expirar Pedido de Voo"
      confirmMessage="Expirar"
      cancelMessage="Cancelar"
      maxWidth="sm"
      fullWidth
      useFullScreen={false}
    >
      <Grid container spacing={1}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Informe a justificativa para marcar este pedido de voo como expirado.
          </Typography>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <InputV2
            label="Justificativa"
            value={justificativa}
            onChange={(e) => {
              setJustificativa(e.target.value);
              if (e.target.value && e.target.value.trim()) setJustificativaError(false);
            }}
            multiline
            rows={3}
            isRequired
            error={justificativaError}
          />
        </Grid>
      </Grid>
    </DialogDefaultV2>
  );
};

ExpirarDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ExpirarDialog;
